import { render, staticRenderFns } from "./icon_menu.vue?vue&type=template&id=8fa78a54&scoped=true"
import script from "./icon_menu.vue?vue&type=script&lang=js"
export * from "./icon_menu.vue?vue&type=script&lang=js"
import style0 from "./icon_menu.vue?vue&type=style&index=0&id=8fa78a54&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa78a54",
  null
  
)

export default component.exports